const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
type WatermarkProps = {
  /** Horizontal placement relative to the section. */
  position?: 'center' | 'left' | 'right';
  /** Vertical placement relative to the section. */
  align?: 'center' | 'top';
  /** Max rendered width in pixels — vary slightly between sections. */
  size?: number;
  /** Use on dark backgrounds so the mark reads as light instead of a white block. */
  dark?: boolean;
  /** Opacity between 0.04 and 0.07. */
  opacity?: number;
};
const positionClasses: Record<NonNullable<WatermarkProps['position']>, string> = {
  center: 'left-1/2 -translate-x-1/2',
  left: 'left-0 -translate-x-1/4',
  right: 'right-0 translate-x-1/4'
};
const alignClasses: Record<NonNullable<WatermarkProps['align']>, string> = {
  center: 'top-1/2 -translate-y-1/2',
  top: 'top-0 -translate-y-1/4'
};
export function Watermark({
  position = 'center',
  align = 'center',
  size = 800,
  dark = false,
  opacity = 0.06
}: WatermarkProps) {
  return <img src={LOGO_URL} alt="" aria-hidden="true" className={`pointer-events-none select-none absolute z-0 w-[130%] ${positionClasses[position]} ${alignClasses[align]} ${dark ? 'invert mix-blend-screen' : 'mix-blend-multiply'}`} style={{
    maxWidth: `${size}px`,
    opacity
  }} data-id="element-432" data-mp="d7j6mkyf13u1" />;
}